import React from "react";
import { FaTimes } from "react-icons/fa";
import styles from "./CrossButton.module.css";

interface CloseButtonProps {
  onClick: () => void;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  title = "Close",
  style,
  className = "",
}) => (
  <button
    type="button"
    className={`${styles.closeBtn} ${className}`}
    title={title}
    aria-label={title}
    onClick={onClick}
    style={style}
  >
    <FaTimes size={22} />
  </button>
);

export default CloseButton;
